import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { SidenavContentComponent } from './sidenav-content/sidenav-content.component';
import {
  MatIconModule,
  MatTableModule,
  MatButtonModule,
  MatListModule,
  MatMenuModule,
  MatGridListModule,
  MatBadgeModule,
  MatProgressSpinnerModule,
  MatDialogModule
} from '@angular/material';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CustomMenuComponent } from './custom-menu/custom-menu.component';

@NgModule({
  declarations: [
    NavbarComponent,
    SidenavContentComponent,
    LoadingSpinnerComponent,
    CustomMenuComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    MatGridListModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    ScrollingModule
  ],
  exports: [
    NavbarComponent,
    SidenavContentComponent,
    LoadingSpinnerComponent,
  ],
  providers: [],
})
export class AppCommonModule { }
